import React from "react";
import styles from "./styles.module.scss";
import { CaptureCards } from "../captureCards";
import { TotalCaptures } from "../totalCaptures";
import { UseApiCallInternalDashboard } from "pages/internal-dashboard/hooks/use-api-call";
import { useCurrentUserContext } from "providers";
import { SubscriptionHistoryTable } from "../subscriptionHistoryTable";
import { CurrentSubscription } from "../currentSubscription";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";
import { useRecoilState } from "recoil";
import { persistedUserOrStrikerId } from "store/atom";

export const CaptureDetails = ({
  userDetails,
  currentSubscription,
  currentPlanObj,
  currentSubscriptionRefetch,
}) => {
  const userID = userDetails?.id;

  const { data: captureCounts, isLoading: captureCountsLoading } =
    UseApiCallForOldDashboardData({
      url: "get_user_video_count",
      method: "POST",
      skip: !userID,
      body: {
        userID: userID,
      },
    });

  const { data: subscriptionHistory, isLoading: subscriptionHistoryLoading } =
    UseApiCallForOldDashboardData({
      url: "get_user_subscription",
      method: "POST",
      skip: !userID,
      body: {
        userID: userID,
      },
    });

  return (
    <div className={styles.capture}>
      <h2 className={styles.heading}>Capture Details</h2>
      <div className={styles.captureBody}>
        <CaptureCards
          captureCounts={captureCounts?.videoCount}
          capturePercentage={captureCounts?.percentages}
        />
        <TotalCaptures userID={userDetails?.id} />
        <CurrentSubscription
          userID={userDetails?.id}
          totalRevenue={subscriptionHistory?.totalAmount}
          currentSubscription={currentSubscription}
          currentPlanObj={currentPlanObj}
          currentSubscriptionRefetch={currentSubscriptionRefetch}
        />
        <SubscriptionHistoryTable
          userID={userID}
          subscriptionHistory={subscriptionHistory}
          loading={subscriptionHistoryLoading}
        />
      </div>
    </div>
  );
};
